function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { AxiosHeaders } from 'axios';
import { constructFormData } from 'api/attachments/construct-form-data';
import { HttpClient } from 'api/http-client';
class UserHttpClient extends HttpClient {
    async getSupportedLanguageList() {
        return this.get('/users/supported-languages');
    }
    async getProfile() {
        return this.get('/users/profile');
    }
    async updateMeta(payload) {
        return this.put('/users/meta', payload);
    }
    async updateMetaDataUser([, userId], payload) {
        return this.put(`/users/${userId}/meta`, payload);
    }
    async updateCurrentUser(payload) {
        return this.put('/users', payload);
    }
    async getAllUsers() {
        return this.get('/users');
    }
    async getUser(userId) {
        return this.get(`/users/${userId}`);
    }
    async getUsersByIds(userIds) {
        const queryString = userIds.join(',');
        return this.get(`/users/bulk?userIds=${queryString}`);
    }
    async getUsersByEmailIds(userEmailIds) {
        const queryString = userEmailIds.join(',');
        return this.get(`/users/users-by-emails?userEmailIds=${queryString}`);
    }
    async createUser(payload) {
        return this.post('/users', payload);
    }
    async setupProfileWithToken(payload) {
        return this.post(`/users/signup?token=${payload.token}`, payload);
    }
    async save(payload, token) {
        if (token) {
            return this.put(`/users/${payload.userId}?token=${token}`, payload);
        }
        return this.put(`/users/${payload.userId}`, payload);
    }
    async getDetailsFromToken(token) {
        return this.post(`/users/auth?token=${token}`);
    }
    getSession(token) {
        return this.get('/users/get-session', {
            params: {
                token
            },
            headers: new AxiosHeaders({})
        });
    }
    getMagicLink(emailId) {
        return this.get('/users/get-magic-link', {
            params: {
                emailId
            },
            headers: new AxiosHeaders({})
        });
    }
    createCustomerAPiKey(payload) {
        return this.post('/users/create-customer-api-key-with-token', payload);
    }
    async changePassword(payload) {
        return this.post(`/users/reset/${payload.user.userId}`, payload.password);
    }
    async resetPassword(payload) {
        // TODO: Remove the duplicate token param sending once api fixes it.
        return this.put(`/users/reset?token=${payload.token}`, payload);
    }
    async forgotPassword(userId) {
        return this.post(`/users/forgot/${userId}`);
    }
    async triggerResetPasswordEmail(email) {
        return this.post('/users/forgot', {
            emailId: email
        });
    }
    async uploadProfilePic(file) {
        const formData = constructFormData(file, {});
        return this.post('/users/photo', formData);
    }
    async deactivateUser(userId) {
        return this.put(`/users/deactivate/${userId}`);
    }
    async reactivateUser(userId) {
        return this.put(`/members/activate/${userId}`); // TODO: /users should slowly migrate to /members
    }
    async bulkCreate(payload) {
        return this.post('/users/bulk-action', payload);
    }
    async updateHubspot(payload) {
        return this.put('/hubspot/contact', payload);
    }
    async logout() {
        return this.post('/users/logout');
    }
    constructor(...args){
        super(...args), _define_property(this, "bulkUpdateOrgChart", async (payload)=>{
            return this.put(`/users/bulk-org-tree?action=${payload.action}`, payload.data);
        }), _define_property(this, "replaceUserInOrgChart", async (oldUser, newUser)=>{
            return this.put(`/users/${oldUser}/replace-user/${newUser}`);
        }), _define_property(this, "clearOktaSession", async ()=>this.post('/users/clear-session', undefined, {
                fetchOptions: {
                    credentials: 'same-origin'
                }
            })), _define_property(this, "getCliToken", async ()=>{
            return this.get('/users/cli-token');
        }), _define_property(this, "getMarketplaceAuthToken", async ()=>{
            return this.get('/users/marketplace-token');
        });
    }
}
export const UserAPI = new UserHttpClient();
